export default {
    intro: 'Listen carefully and write it down correctly!',
    introHandwriting: 'Listen carefully and write the letters correctly by hand!',
    wordIndex: 'Word {index}',
    common: {
        handwritingView: 'View handwriting',
    },
    student: {
        myAnswer: 'My Submitted Answer',
        noAnswer: 'No answer was submitted.',
        answer: 'Correct Answer',
        attemptNumber: 'Round {number}',
        listen: 'Listen carefully!<br />Pay close attention!',
        teacherReading: 'The Teacher is reading it aloud',
        listenDirect: 'Listen carefully to the sentence the Teacher is reading aloud!',
        placeholder: 'Please enter the correct answer.',
        wrongToast: "Oops, that's incorrect. Try entering it again.",
        writeEnd: 'End Writing',
        submitAnswer: 'Submit Answer',
        waitingStart: "Please wait for the Teacher's signal to start writing!",
        threeWrong: "You've used all 3 chances... Please wait for the Teacher to reveal the correct answer!",
    },
    teacher: {
        setting: {
            activity: 'Activity Content',
            number: 'Number',
            title: 'Dictation 📝',
            message: 'If you play the sentence now, Students may also hear it!',
            subMessage: 'Do you still want to play it?',
            optionSubMessage: 'After playing it once, this confirmation will not appear again.',
            confirmText: 'Play',
            addQuestion: {
                button: 'Add Question',
                title: 'Add Dictation Questions',
                guide: 'You can paste text copied from outside. Enter one question per line.',
                notice: '※ Line breaks separate questions. 2+ consecutive spaces are treated as a space.',
                columnQuestion: 'Question to add',
                cancelConfirm: {
                    title: 'Discard entered questions?',
                    body: 'Cancelling will discard all entered questions and they will not be added.\nDo you want to continue?',
                },
                deleteConfirm: {
                    title: 'Delete this question?',
                    body: 'If you delete it, the added question will be removed from the list.\nDo you want to continue?',
                },
                registering: 'Adding questions...',
                noticeTitle: 'Notice',
                emptyData: 'Please enter at least one question.',
                partialFail: '{count} question(s) could not be added due to TTS generation failure.',
                duplicateSkip: '{count} question(s) were not added because they already exist.',
                addFail: 'Failed to add questions.',
                deleteFail: 'Failed to delete the question.',
                ttsSuccess: 'TTS has been generated.',
                ttsFail: 'Failed to generate TTS.',
            },
            inputMode: 'Answer Input Method',
            inputModeKeyboard: 'Keyboard',
            inputModeHandwriting: 'Handwriting',
            tracing: 'Tracing',
            previewGuide: 'Press to listen to a preview!',
            generateTts: 'Generate TTS',
        },
        handwritingModal: {
            title: "Students' Handwritten Answers",
            answer: 'Correct Answer',
            notAttempted: 'Not attempted',
        },
        question: 'Question',
        intro: 'Please select a word from the questions on the left.',
        ttsStart: 'Play & Start Writing',
        directReading: 'Read Aloud',
        startWriting: 'Start Writing',
        completeWriting: 'Finish Writing & Reveal Answer',
        viewStudentResult: 'View All Student Results',
        toast: {
            alreadyDone: 'This word has already been completed.',
            fiveSeconds: 'You can finish writing 5 seconds after starting.',
        },
        result: {
            title: 'Accuracy Per Question',
            order: 'Order',
            question: 'Question',
            answerRate: 'Accuracy',
        },
    },
    table: {
        question: 'Question',
        answerRate: 'Accuracy',
        emptyMessage: 'No content available.',
    },
};
